export default __webpack_public_path__ + "static/media/admed-icon-48px.bfddc7ba.svg";